export namespace Calendar {
  export type DateListItem = { timeAt: Temporal.Instant; id: string };

  export type DateListProps<T extends DateListItem> = {
    items: readonly T[];
    renderItem: (item: T) => React.ReactNode;
    timeZone: string;
    onPressTimeAdd?: (time: Temporal.PlainTime) => void;
  };

  export function combineItemsWithTimes<T extends DateListItem>(
    items: readonly T[],
    timeZone: string,
  ) {
    let earliestItemTime = Temporal.PlainTime.from("07:00");
    const itemsWithTimes: { type: "item"; item: T; time: Temporal.PlainTime }[] = [];
    for (const item of items) {
      const time = item.timeAt.toZonedDateTimeISO(timeZone).toPlainTime();
      if (Temporal.PlainTime.compare(time, earliestItemTime) < 0) {
        earliestItemTime = time;
      }
      itemsWithTimes.push({
        type: "item" as const,
        item,
        time,
      });
    }
    earliestItemTime = earliestItemTime.subtract({ hours: 1 });

    return [
      ...TIMES.filter(({ time }) => Temporal.PlainTime.compare(time, earliestItemTime) > 0),
      ...itemsWithTimes,
    ].sort((a, b) => Temporal.PlainTime.compare(a.time, b.time));
  }
}

const TIMES = [
  Temporal.PlainTime.from("00:00"),
  Temporal.PlainTime.from("01:00"),
  Temporal.PlainTime.from("02:00"),
  Temporal.PlainTime.from("03:00"),
  Temporal.PlainTime.from("04:00"),
  Temporal.PlainTime.from("05:00"),
  Temporal.PlainTime.from("06:00"),
  Temporal.PlainTime.from("07:00"),
  Temporal.PlainTime.from("08:00"),
  Temporal.PlainTime.from("09:00"),
  Temporal.PlainTime.from("10:00"),
  Temporal.PlainTime.from("11:00"),
  Temporal.PlainTime.from("12:00"),
  Temporal.PlainTime.from("13:00"),
  Temporal.PlainTime.from("14:00"),
  Temporal.PlainTime.from("15:00"),
  Temporal.PlainTime.from("16:00"),
  Temporal.PlainTime.from("17:00"),
  Temporal.PlainTime.from("18:00"),
  Temporal.PlainTime.from("19:00"),
  Temporal.PlainTime.from("20:00"),
  Temporal.PlainTime.from("21:00"),
  Temporal.PlainTime.from("22:00"),
  Temporal.PlainTime.from("23:00"),
].map((time) => ({ type: "time" as const, time }));
